import MarkdownContentRenderer from 'fitify-ui-landing/src/components/Markdown/MarkdownContentRenderer'
import type { NextPage } from 'next'
import { useTranslation } from 'next-i18next'

import { Layout } from '@/components/layouts/Layout'
import { getStaticPropsTranslations } from '@/utils/i18n'

import content from '../../public/assets/markdown/nutrition-science-approach.md'

const NutritionSciencePage: NextPage = () => {
  const { t } = useTranslation()
  return (
    <Layout
      seo={{
        title: 'Our Scientific Approach to Nutrition | Nutria',
        description: t('cl_landing_nutria_science_meta_description'),
      }}
    >
      <article>
        <MarkdownContentRenderer content={content} />
      </article>
    </Layout>
  )
}

export default NutritionSciencePage

export async function getStaticProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await getStaticPropsTranslations(locale)),
    },
  }
}
